import { Box, Typography } from '@mui/material';
import ExoAvatar from '../exo/ExoAvatar';
import { useTranslation } from 'react-i18next';
import { NavLink, useNavigate } from 'react-router-dom';

export const ECSenderPreview = ({
  sender,
  type,
  avatarSize = '40px',
  to,
  cc,
  subject,
}) => {
  const { t } = useTranslation();

  const { id } = sender;

  const senderTypeMap = {
    companyLead: {
      label: `${sender?.nameShort || sender?.name}`,
      to: `/leads/companies/${id}`,
    },
    company: {
      label: `${sender?.nameShort || sender?.name}`,
      to: `/companies/${id}`,
    },
    personLead: {
      label: `${sender?.firstName || sender?.lastName}`,
      to: `/leads/persons/${id}`,
    },
    contact: {
      label: `${sender?.firstName || sender?.lastName}`,
      to: `/contacts/${id}`,
    },
  };

  const navigate = useNavigate();

  function handleClickAvatar() {
    const route = senderTypeMap[type]?.to;
    navigate(route);
  }

  return (
    <Box className="w-full flex items-start gap-2 overflow-hidden">
      <ExoAvatar
        onClick={senderTypeMap[type]?.to ? handleClickAvatar : undefined}
        size={avatarSize}
        className=" shadow-sm"
        name={senderTypeMap[type]?.label || sender?.email}
      />
      <Box className="flex flex-col justify-center h-full w-full overflow-hidden">
        <Typography
          fontWeight={600}
          textAlign="start"
          className="w-full text-ellipsis"
        >
          {senderTypeMap[type]?.label || sender?.email}
        </Typography>
        {to && to.length > 0 && (
          <Typography fontSize={12}>
            <span style={{ fontWeight: 500 }}>{t('to')}:</span>
            {to.map((email) => (
              <span className="pl-2 opacity-50">{`<${email}>`}</span>
            ))}
          </Typography>
        )}
        {cc && cc.length > 0 && (
          <Typography fontSize={12}>
            <span style={{ fontWeight: 500 }}>{t('cc')}:</span>
            {cc.map((email) => (
              <span className="pl-2 opacity-50">{`<${email}>`}</span>
            ))}
          </Typography>
        )}
        {subject && (
          <Typography
            textAlign="start"
            fontSize="11px"
            fontWeight={500}
            className="w-full text-ellipsis overflow-hidden whitespace-nowrap"
          >
            {subject}
          </Typography>
        )}
      </Box>
    </Box>
  );
};
